import { useState } from 'react';
import { Button } from '../../../design-system/button/button';
import { Modal, ModalContent, ModalDescription, ModalTitle } from '../../../design-system/modal/modal';
import { Stack } from '../../../design-system/stack/stack';
import { OpenSeapointAccount } from '../components/open-seapoint-account/open-seapoint-account';

export const MissingSeapointAccount = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <Stack space={4}>
      <h1 className="text-xl font-medium leading-[28px] tracking-[-0.02em]">Introducing Payroll</h1>
      <p className="font-normal leading-[20px] tracking-[-0.02em] text-seapoint-gray-text">
        Never stress about individual employee payroll again. Upload pay schedules for automatic scanning, or let our AI
        read your transaction history to pre-populate payroll details - then process payroll in just a few clicks. To
        create your first payroll, you need to open Seapoint account:
      </p>
      <p className="font-normal leading-[20px] tracking-[-0.02em] text-seapoint-gray-text">
        To create your first payroll, you need to open Seapoint account:
      </p>
      <div className="mt-3 w-full">
        <OpenSeapointAccount onOpenAccount={() => setIsModalOpen(true)} />
      </div>
      {isModalOpen && (
        <Modal open={isModalOpen} onOpenChange={setIsModalOpen}>
          <ModalContent className="h-auto w-[400px]">
            <ModalTitle className="px-4 pt-4">Open Seapoint Account</ModalTitle>
            <ModalDescription className="p-4">
              <Stack space={6} align="stretch">
                <p className="text-sm leading-[20px] tracking-[-0.02em] text-seapoint-gray-text">
                  To open a Seapoint account, please contact someone from the Seapoint team.
                </p>
                <Button variant="secondary" onClick={() => setIsModalOpen(false)}>
                  Close
                </Button>
              </Stack>
            </ModalDescription>
          </ModalContent>
        </Modal>
      )}
    </Stack>
  );
};
